import { Alert, AlertProps, AlertTitle, Collapse } from "@mui/material"
import React, { Fragment, useEffect, useState } from "react"
import { WidthOpt } from "../../assets/inputStyles"
import { useStyles } from "./styles"

interface NexAlertProps extends AlertProps {
    animate?: boolean
    children: React.ReactNode
    className?: string
    disableGutter?: boolean
    gutterBottom?: WidthOpt
    onClose?: () => void
    title?: string
}

export const NexAlert = ({
    animate,
    children,
    className,
    disableGutter,
    gutterBottom = "md",
    onClose,
    title,
    severity = "error",
    ...props
}: NexAlertProps) => {
    const { classes, cx } = useStyles()

    const [open, setOpen] = useState(false)

    useEffect(() => {
        if (animate) {
            setOpen(true)
        }
    }, [])

    const handleClose = () => {
        setOpen(false)

        if (onClose != null) {
            if (animate) {
                setTimeout(() => onClose(), 300)
            } else {
                onClose()
            }
        }
    }

    let errorContents: React.ReactNode | React.ReactNode[]
    if (Array.isArray(children)) {
        if (children.length === 0) {
            errorContents = "Unknown Error. (Error array was empty.)"
        } else {
            errorContents = children.map((error, idx) => {
                return <Fragment key={idx}>{error}</Fragment>
            })
        }
    } else {
        errorContents = children
    }

    const alert = (
        <Alert
            onClose={onClose ? handleClose : undefined}
            className={cx(!disableGutter && classes[`gutterBottom__${gutterBottom}`], className)}
            severity={severity}
            {...props}
        >
            {title && <AlertTitle>{title}</AlertTitle>}
            {errorContents}
        </Alert>
    )

    if (animate) {
        return <Collapse in={open}>{alert}</Collapse>
    }
    return alert
}
